// React & React Router
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

// Form Handling
import { useForm } from "react-hook-form";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { addNewSliderFunc } from "../../../../store/custom-actions/sliders/AddSliderSlicer";

// UI Components
import PageTitle from "../../../layouts/PageTitle";
import FormField from "../../../components/ui/FormField";
import TextAreaField from "../../../components/ui/TextAreaField";
import MediaSelectorButton from "../../../components/media/MediaSelectorButton";
import SubmitButton from "../../../components/ui/SubmitButton";
import CheckboxField from "../../../components/ui/CheckboxField";

function NewSliderForm() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      title: "",
      description: "",
      btn_text: "",
      link: "",
      mobile_image: null,
      image: null,
      active: 1,
    },
  });

  const { loading: submitLoading } = useSelector(
    (state) => state.addNewSliderSlicer
  );

  const onSubmit = async (data) => {
    const result = await dispatch(addNewSliderFunc({ data }));
    if (addNewSliderFunc.fulfilled.match(result)) {
      reset();
      navigate("/sliders-settings");
    }
  };

  return (
    <>
      <PageTitle
        motherMenu="Home"
        activeMenu="New Slider"
        customClasses="my-0"
      />

      {/* Top Right Buttons */}
      <div className="relative flex items-center justify-end my-3">
        <Link to="/sliders-settings">
          <button type="button" className="btn btn-secondary sw-btn-back me-2">
            Back
          </button>
        </Link>
        <SubmitButton isLoading={submitLoading} form="submit-form" />
      </div>

      {/* Main Form */}
      <div className="col">
        <div className="card p-4">
          <form id="submit-form" onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <div className="form-group mb-3 col-md-6">
                <FormField
                  label="Title"
                  name="title"
                  register={register}
                  errors={errors}
                />
              </div>
              <div className="form-group mb-3 col-md-6">
                <FormField
                  label="Button Text"
                  name="btn_text"
                  register={register}
                  errors={errors}
                />
              </div>
              <div className="form-group mb-3 col-12">
                <FormField
                  label="Path Link"
                  name="link"
                  register={register}
                  errors={errors}
                />
              </div>
              <div className="form-group mb-3 col-12">
                <CheckboxField
                  name="active"
                  label="Activity"
                  register={register}
                  errors={errors}
                />
              </div>
            </div>

            <div className="row">
              <div className="form-group mb-3 col-12">
                <TextAreaField
                  label="Description"
                  name="description"
                  isRichTextEditor
                  register={register}
                  errors={errors}
                  watch={watch}
                  setValue={setValue}
                />
              </div>
            </div>

            <div className="row">
              <div className="form-group mb-3 col-md-6">
                <MediaSelectorButton
                  label="Slider Image"
                  inputName="image"
                  required
                  register={register}
                  errors={errors}
                  onChange={(val) => setValue("image", val)}
                />
              </div>
              <div className="form-group mb-3 col-md-6">
                <MediaSelectorButton
                  label="Slider Mobile Image"
                  inputName="mobile_image"
                  required
                  register={register}
                  errors={errors}
                  onChange={(val) => setValue("mobile_image", val)}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default NewSliderForm;
